module.exports = __webpack_public_path__ + "img/icas.23efd901.png";